import { AxiosResponse } from "axios";
import { ThunkAction } from "redux-thunk";
import { AppStateType } from "../reducers/mainReducer";

import {
  fetchNotificationsRequest,
  fetchNotificationsSuccess,
  fetchNotificationsFailure,

  fetchNotificationsCountRequest,
  fetchNotificationsCountSuccess,
  fetchNotificationsCountFailure,

  readNotificationsRequest,
  readNotificationsSuccess,
  readNotificationsFailure,

  restoreNotificationRequest,
  restoreNotificationSuccess,
  restoreNotificationFailure,

  readAllNotificationsRequest,
  readAllNotificationsSuccess,
  readAllNotificationsFailure,

  deleteAllNotificationsRequest,
  deleteAllNotificationsSuccess,
  deleteAllNotificationsFailure,

  deleteNotificationRequest,
  deleteNotificationSuccess,
  deleteNotificationFailure,

  clearNotificationsRequest,
  clearNotificationsSuccess,
} from "redux/slices/notificationsSlice";
import { PaginatedNotificationsType, NotificationsCountType, NotificationCategoryType } from "notifications/types";

import * as API from "api/notifications";

/** Получение уведомлений площадки ТП */
export interface IFetchNotificationsParams {
  page: number;
  page_size: number;
  is_read?: boolean;
  is_purchaser?: boolean;
  category?: NotificationCategoryType;
}

export const fetchNotifications = (params: IFetchNotificationsParams, isUpdate?: boolean): ThunkAction<
  Promise<PaginatedNotificationsType>,
  AppStateType,
  undefined,
  any
> => async (dispatch) => {
  dispatch(fetchNotificationsRequest(null));
  try {
    const response: AxiosResponse<PaginatedNotificationsType> = await API.getNotifications({ params });

    dispatch(fetchNotificationsSuccess({ data: response.data, params, isUpdate }));
    
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    dispatch(fetchNotificationsFailure(error));

    return Promise.reject(error);
  }
};

/** Получение количества уведомлений площадки ТП */
export const fetchNotificationsCount = (): ThunkAction<
  Promise<NotificationsCountType>,
  AppStateType,
  undefined,
  any
> => async (dispatch) => {
  dispatch(fetchNotificationsCountRequest(null));
  try {
    const response: AxiosResponse<NotificationsCountType> = await API.getNotificationsCount();

    dispatch(fetchNotificationsCountSuccess(response.data));
    
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    dispatch(fetchNotificationsCountFailure(error));

    return Promise.reject(error);
  }
};

/** Получение уведомлений площадки ТП */
export const readNotification = (id: number): ThunkAction<
  Promise<PaginatedNotificationsType>,
  AppStateType,
  undefined,
  any
> => async (dispatch) => {
  dispatch(readNotificationsRequest(null));
  try {
    const response: AxiosResponse<PaginatedNotificationsType> = await API.postNotification({ id });

    dispatch(readNotificationsSuccess(id));
    
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    dispatch(readNotificationsFailure(error));

    return Promise.reject(error);
  }
};

/** Чтение всех уведомлений площадки ТП */
export interface IReadAllNotificationsParams {
  category?: NotificationCategoryType;
}

export const readAllNotifications = (
  params?: IReadAllNotificationsParams,
): ThunkAction<
  Promise<PaginatedNotificationsType>,
  AppStateType,
  undefined,
  any
> => async (dispatch) => {
  dispatch(readAllNotificationsRequest(null));
  try {
    const response: AxiosResponse<PaginatedNotificationsType> = await API.postReadAllNotifications({ params });

    dispatch(readAllNotificationsSuccess(params?.category));
    
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    dispatch(readAllNotificationsFailure(error));

    return Promise.reject(error);
  }
};

/** Удаление всех уведомлений площадки ТП */
export interface IDeleteAllNotificationsParams {
  category?: NotificationCategoryType;
}

export const deleteAllNotifications = (
  params?: IDeleteAllNotificationsParams
): ThunkAction<
  Promise<PaginatedNotificationsType>,
  AppStateType,
  undefined,
  any
> => async (dispatch) => {
  dispatch(deleteAllNotificationsRequest(null));
  try {
    const response: AxiosResponse<PaginatedNotificationsType> = await API.postDeleteAllNotifications({ params });

    dispatch(deleteAllNotificationsSuccess(response.data));
    
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    dispatch(deleteAllNotificationsFailure(error));

    return Promise.reject(error);
  }
};

/** Удаление уведомления площадки ТП */
export const deleteNotification = (
  id: number
): ThunkAction<
  Promise<PaginatedNotificationsType>,
  AppStateType,
  undefined,
  any
> => async (dispatch) => {
  dispatch(deleteNotificationRequest(null));
  try {
    const response: AxiosResponse<PaginatedNotificationsType> = await API.deleteNotification({ id });

    dispatch(deleteNotificationSuccess(id));
    
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    dispatch(deleteNotificationFailure(error));

    return Promise.reject(error);
  }
};

/** Пометка уведомления ТП как непрочитанного */
export const restoreNotification = (
  id: number
): ThunkAction<
  Promise<any>,
  AppStateType,
  undefined,
  any
> => async (dispatch) => {
  dispatch(restoreNotificationRequest(null));
  try {
    const response: AxiosResponse<PaginatedNotificationsType> = await API.postRestoreNotification({ id });

    dispatch(restoreNotificationSuccess(id));
    
    return Promise.resolve(response.data);
  } catch (error) {
    dispatch(restoreNotificationFailure(error));

    return Promise.reject(error);
  }
};

/** Очистка редакса от уведомлений */
export const clearNotifications = (): ThunkAction<
  Promise<any>,
  AppStateType,
  undefined,
  any
> => async (dispatch) => {
  dispatch(clearNotificationsRequest(null));
  try {
    dispatch(clearNotificationsSuccess(null));
    
    return Promise.resolve();
  } catch (error) {
    console.error(error);

    return Promise.reject(error);
  }
};